var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9633_175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 49C38.031 49 49 38.031 49 24.5C49 10.969 38.031 0 24.5 0C10.969 0 0 10.969 0 24.5C0 38.031 10.969 49 24.5 49Z",
    fill: "#121D27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.535 24.188C31.5129 23.2194 31.7618 22.2639 32.2537 21.4292C32.7456 20.5945 33.4609 19.9139 34.319 19.464C33.778 18.7132 33.0703 18.0981 32.2515 17.6669C31.4328 17.2357 30.5251 17.0003 29.6 16.979C27.622 16.823 25.46 18.132 24.669 18.132C23.833 18.132 21.917 17.032 20.412 17.032C17.304 17.084 14 19.514 14 24.456C14.0136 25.998 14.284 27.5269 14.8 28.98C15.513 31.025 18.087 36.039 20.773 35.956C22.173 35.923 23.173 34.956 24.996 34.956C26.768 34.956 27.687 35.956 29.253 35.956C31.961 35.917 34.29 31.356 34.97 29.309C33.9527 28.8943 33.0822 28.1856 32.4698 27.2736C31.8574 26.3615 31.5309 25.2876 31.532 24.189L31.535 24.188ZM28.381 15.04C28.8738 14.4974 29.2474 13.8575 29.4779 13.1617C29.7083 12.4659 29.7905 11.7295 29.719 11C28.2602 11.1561 26.9118 11.8495 25.936 12.945C25.4361 13.4789 25.0514 14.11 24.8059 14.7991C24.5604 15.4881 24.4593 16.2202 24.509 16.95C25.2603 16.966 26.0045 16.8008 26.6785 16.4683C27.3524 16.1358 27.9364 15.6459 28.381 15.04Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9633_175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/app_store.229c495a85f109d137bf3733993149dc.svg";
export { ForwardRef as ReactComponent };